import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const CartDiscount = ({ label , price , currency  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, label)), /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__value cart-totals__value--discount"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        type: "discount"
    })))
;

export { CartDiscount };
//# sourceMappingURL=CartDiscount.js.map
